export const incidentValidation = {
  shortDescription: {
    type: 'string',
    required: true,
  },
  severity: {
    type: 'string',
    required: true,
  },
  linkToDetails: {
    type: 'string',
    link: true,
  },
  notes: {
    type: 'string',
  },
};
